import React from "react";
import "../../../styles/dashboardCardTokens.css";
import "../../Dashboard/components/recommendedListingsCard.css";
import "./BuySignalsListingCard.css";

export default function BuySignalsListingCard({ listing, isSelected, onClick }) {
  const getScoreColor = (score) => {
    if (score >= 90) return "green";
    if (score >= 80) return "yellow";
    return "gray";
  };

  const getTagColor = (tag) => {
    if (tag === "Best Fit") return "green";
    if (tag === "Fast Mover") return "blue";
    return "orange";
  };

  const scoreColor = getScoreColor(listing.score);
  const mainTag = listing.tags[0] || "Neutral";

  return (
    <article
      className={`rlRow ${isSelected ? "bs-listing-row-selected" : ""}`}
      onClick={onClick}
    >
      <div className="rlThumbCol">
        <img
          className="rlThumb"
          src={listing.thumbnailUrl}
          alt={`${listing.year} ${listing.make} ${listing.model}`}
          onError={(e) => {
            e.target.src = "https://via.placeholder.com/50x60/2a2a2a/666?text=Car";
          }}
        />
      </div>

      <div className="rlMain">
        <div className="rlTopLine">
          <div className="rlVehicle">{listing.year} {listing.make} {listing.model} {listing.trim}</div>
          <div className={`rlRankBadge bs-rank-badge-${scoreColor}`}>
            <span className="rlRankNum">{listing.score}</span>
          </div>
        </div>

        <div className="rlPriceLine">
          <span className="rlMainPrice">${listing.price.toLocaleString()}</span>
          <span className="rlMileage">{listing.mileage.toLocaleString()}</span>
          <span className="rlMeta">
            {listing.sellerType} • {listing.location} • {listing.distanceMi} mi
            {mainTag && <span className={`rlChip bs-fit-tag-${getTagColor(mainTag)}`}>{mainTag}</span>}
          </span>
        </div>
      </div>

      <div className="rlRightPrice">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
          <button
            className="bs-view-deal-button"
            onClick={(e) => {
              e.stopPropagation();
              onClick();
            }}
          >
            View Deal
          </button>
          <div className="bs-profit-line">
            Potential Marginal Profit: <span className="bs-profit-amount">${listing.profitPotential.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </article>
  );
}

